module.exports = "//trvimg.r10s.jp/share/m17n/8fa38af91714bb5c6e77b7ba8736f1dc.svg";


// WEBPACK FOOTER //
// ./~/url-loader?limit=10000&mimetype=image/svg+xml&publicPath=/trvimg.r10s.jp/share/m17n/!./src/img/common/icons/default.svg